export const serverUrl =
  process.env.REACT_APP_SERVER_ADDRESS || "http://localhost:4000";
